export default {
    goodsSku: {
        page: {
            commonSKU: '新增普通产品',
            threeParties: '同步三方',
            packageSKU: '新增组合产品',
            Set: '套',
            submitTip: '确认提交吗？',
            Sync: '同步',
            SelectChannel: '选择渠道',
            synchronizeProducts: '请选择一个需要同步商品的第三方渠道',
            SKU: '该SKU不可推送!',
            SKUNO: '该SKU已推送，不可重复推送!',

            // 未翻译
            ExpirationStatus: '过期状态',
            CertificatePeriod: '证书有效期',
        },
        detail: {
            hsCode: '海关商品编码',
            originPlace: '原产地',
            barcodeTip: '修改在库商品条码前，请先联系客户。',
            BasicInformation: '基础信息',
            SaveDraft: '保存为草稿',
            Description: '描述',
            ProductType: '产品类型',
            ProductClassification: '产品分类',
            Barcode: '条形码',
            Supplier: '供应商',
            PurchasingDepartment: '采购部门',
            Purchaser: '采购员',
            Brand: '品牌',
            packagingBarcode: '外包装条形码',
            SeasonalProducts: '季节性产品',
            Merchandiser: 'ebay跟单员',
            Merchandiser2: 'amz跟单员',
            ContinueSell: '是否继续在售',
            Currency: '货币',
            Price: '价格',
            InventoryProducts: '库存产品',
            PurchasedItems: '进货物品',
            SellingItems: '销售物品',
            Fragile: '易碎品',
            DangerousGoods: '危险品',
            Flammable: '易燃',
            Picture: '图片',
            AttributeTable: '属性表',
            length: '单品长度',
            width: '单品宽度',
            height: '单品高度',
            weight: '单品重量',
            UnitVolume: '单位体积',
            qty: '数量',
            cartonLength: '外箱长度',
            cartonWidth: '外箱宽度',
            cartonHeight: '外箱高度',
            cartonWeight: '外箱重量',
            cartonVolume: '箱子体积',
            stockQty: '库存数量',

            // 未翻译
            costPrice: '成本价',
            salesPrice: '销售价',
            activityPrice: '活动价',
            marketPrice: '市场价',
            distributionPrice: '分销价',
            wholesalePrice: '批发价',
            clearingPrice: '结算价',
            CertificateList: '证书列表',
            CertificateName: '证书名称',
            CertificatePeriod: '证书有效期',
            CertificateRemarks: '证书备注',
            PleaseUpload: '请先上传',
            PleaseContent: '请输入证书内容',
            leastCertificate: '至少有一个证书',
            UseSystemBarcode: '是否使用系统条形码',
            Length: '长',
            Width: '宽',
            Height: '高',
            Weight: '重量',
            Size: '尺寸',
            Volume: '体积',
            skuDesc: '产品描述',
            itemPerCarton: '每箱件数',
            isWine: '是否酒水',
            valueDa: '请输入大于0的值',
            oversizeDimensionConfirm: '尺寸较大，请确认填写是否正确。当前单位为 cm。'
        },
        package: {
          BasicInformation: '套餐基础信息',
          packageName: '套餐名称',
          packageSkuCode: '套餐SKU编码',
          costPrice: '成本价',
          salesPrice: '销售价',
          packageProductMsg: '套餐内商品信息',
          delete: '批量删除',
          skuName: 'SKU商品名',
          Qty: 'Qty套餐内数量',
          msgErrorText: '套餐内商品数量不能为空或0',
          msgErrorText2: '提示： 在组合产品中，您填写的商品总数为1个，请核实并确认填写的数量是否准确。如有误，请及时修改。'
        }
    }
};
